const toReverse = value => value.reverse();
export default toReverse;
